import { useState } from "react";
import type { FormEvent } from "react";
import {
  describeFailure,
  describeTotals,
  importInBatches,
  parseImportCards,
  postImportBatch,
} from "../import-batches";

export default function ManagePostcardsPage() {
  const [cardsJson, setCardsJson] = useState("");
  const [status, setStatus] = useState("");
  const [busy, setBusy] = useState(false);

  async function addCards(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setBusy(true);
    setStatus("Adding cards…");
    try {
      const cards = parseImportCards(cardsJson);
      if (cards.length === 0) throw new Error("Paste at least one card to add.");
      // Small batches, so a large paste cannot outlast the server's timeout — see
      // import-batches.ts.
      const totals = await importInBatches(cards, postImportBatch, {
        onProgress: (saved, remaining) =>
          setStatus(
            `Adding cards… ${cards.length - remaining} of ${cards.length} done ` +
              `(${saved.importedCount} saved, ${saved.skippedCount} already there).`,
          ),
      });
      setStatus(`${describeTotals(totals)}.`);
    } catch (error) {
      setStatus(describeFailure(error, "Could not add cards."));
    } finally {
      setBusy(false);
    }
  }

  return (
    <main>
      <h1>Add Postcrossing cards</h1>
      <form onSubmit={addCards}>
        <label>
          Cards JSON
          <textarea name="cardsJson" value={cardsJson} onChange={(event) => setCardsJson(event.target.value)} required />
        </label>
        <button type="submit" disabled={busy}>{busy ? "Adding cards…" : "Add Postcrossing cards"}</button>
        <p role="status">{status}</p>
      </form>
    </main>
  );
}
